import { render, staticRenderFns } from "./internationalAllocateinvoices.vue?vue&type=template&id=02ec2f74&scoped=true"
import script from "./internationalAllocateinvoices.vue?vue&type=script&lang=js"
export * from "./internationalAllocateinvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec2f74",
  null
  
)

export default component.exports